export const galleries_resi = [
    {
        id: "991",
        title: "Home Theater",
        gallery_id: "991"
    },
    {
        id: "990",
        title: "Whole-Home Integrated Systems",
        gallery_id: "990"
    },
    {
        id: "989",
        title: "Automation Control",
        gallery_id: "989"
    },
    {
        id: "988",
        title: "Smart Lighting",
        gallery_id: "988"
    },
    {
        id: "987",
        title: "Structured Wiring & Home Networking",
        gallery_id: "987"
    },
    // {
    //     id: "986",
    //     title: "Room Acoustics Design",
    //     gallery_id: "986"
    // }
]